import {
  Text,
  Container,
  ContainerGutter,
  ContainerPadding,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { Offer } from 'src/types';
import { InfoCuotaDetails, InfoCuotaHeader, CarlineEquipmentsLayer } from '.';
import { isCommercial } from 'src/bff/get-data-url';
import { getDataServiceConfig } from 'src/feature-app';
import {
  useGetDisclaimer
} from 'src/feature-app/hooks';

export interface InfoCuotaProps {
  offer: Offer;
  isCarousel?: boolean;
  numberOfOffers?: number;
}

export const InfoCuota = (props: InfoCuotaProps) => {
  const { offer } = props;
  const dataService = getDataServiceConfig();
  const disclaimer = useGetDisclaimer(offer.legal);

  const cuota50 = offer.promociones.find(promocion => {
    if (promocion.name == "cuota-50") return true;
    else return false;
  });

  return (
    <>
      <div className="carline-model-set-minheight">
        <div className="carline-model-cuotainfo">
          <Container
            gutter={{ 0: ContainerGutter.static300, 1440: ContainerGutter.static400 }}
            wrap={"always"}
            shrinkContent
          >
            <Container wrap={"always"} gutter={ContainerGutter.dynamic0050}>
              <InfoCuotaHeader offer={offer}/>
              <div>
                <InfoCuotaDetails offer={offer}/>
                {
                  offer.equipamientos && offer.equipamientos.serie.length > 0 && !isCommercial(dataService) && <CarlineEquipmentsLayer equipments={offer.equipamientos} offer={offer}/>
                }
              </div>
            </Container>
            {
              cuota50 && <Container padding={{ top: ContainerPadding.static300 }}><Text>Consigue el 50% del precio indicado durante 6 meses.<Text sup>{disclaimer?.ref}</Text></Text></Container>
            }
          </Container>
        </div>
      </div>
    </>
  );
};
